import React, { memo, useEffect, useRef } from "react";
import { classNames, useTranslate } from "helpers";
import { ReactSVG } from "react-svg";
import { VehicleTireSummaryProps } from "./types";

const VehicleTireSummary: React.FC<VehicleTireSummaryProps> = ({
  vehicleInfo,
  stepCurrent,
}) => {
  const { t } = useTranslate();
  const thisStep = 3;

  const isActive = stepCurrent === thisStep;
  const isCompleted = stepCurrent > thisStep;

  const ref = useRef<HTMLDivElement>(null);

  // auto-scroll kad kartica postane aktivna
  useEffect(() => {
    if (isActive) {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [isActive]);

  if (!isActive && !isCompleted)
    return null;

  return (
    <div
      ref={ref}
      className={classNames(
        `
        bg-white rounded-md border border-blue-100 shadow-xl
        w-[280px] h-[260px]
        flex-shrink-0
        snap-start
        transition-all duration-300
        cursor-pointer
        `,
        isActive
          ? "opacity-100 scale-100"
          : "opacity-70 hover:opacity-100 "
      )}
    >
      <div className="p-3 flex justify-between items-center min-h-[52px]">
        <h3 className="text-sm font-semibold text-slate-800">
          {thisStep + 1}. Gume
        </h3>

        {isCompleted && (
          <div className="bg-green-50 border-2 border-green-500 rounded-full p-1">
            <ReactSVG
              src="/media/icons/check.svg"
              className="w-4 h-4 fill-green-500 stroke-green-500"
            />
          </div>
        )}
      </div>

      <div className="border-t border-slate-200 pb-4 p-4 space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Dimenzije:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.tireDimensions ?? "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Proizvođač:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.tireManufacturer ?? "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Tip:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.tireType ?? "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">DOT:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.dot ?? "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Dubina profila:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.profileDepth != null ? `${vehicleInfo.profileDepth} mm` : "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Run Flat:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.rof != null ? (vehicleInfo.rof ? "Da" : "Ne") : "-"}
          </span>
        </div>

        {/* <div className="flex justify-between text-sm">
          <span className="text-slate-500">Broj guma:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.tireCount ?? "-"}
          </span>
        </div> */}
      </div>
    </div>
  );
};

export default memo(VehicleTireSummary);
